module.exports = __webpack_public_path__ + "static/media/indonesia-flag.7b5c8212.png";